import firebase from "@/plugins/firebase";
import { User } from "@/types";

const auth = {
  namespaced: true,
  state: {
    userSignedIn: false,
    user: {} as User
  },
  getters: {
    user(state: any): User {
      return state.user;
    },

    userSignedIn(state: any): boolean {
      return state.userSignedIn;
    }
  },
  mutations: {
    setUserSignedIn(state: any, isSignedIn: boolean) {
      state.userSignedIn = isSignedIn;
    },

    setUser(state: any, user: User) {
      state.user = user;
    }
  },
  actions: {
    async signIn(context: any, uid: string) {
      const user = {} as User;

      // Get roles of user
      const qs = await firebase
        .firestore()
        .collection("/profiles")
        .where("uid", "==", uid)
        .get();

      const doc = qs.docs[0];

      if (doc.exists) {
        user.id = uid;
        user.firstName = doc.data().firstName;
        user.lastName = doc.data().lastName;
        user.displayName = `${user.firstName} ${user.lastName}`;
        user.email = doc.data().email;
        user.phone = doc.data().phone;
        user.roles = doc.data().roles;
      } else {
        throw "HATA: Kullanıcı profili bulunamadı!";
      }

      context.commit("setUser", user);
      context.commit("setUserSignedIn", true);

      // Get shopping cart
      await context.dispatch("ecommerce/getShoppingCart", user.id, {
        root: true
      });
    },

    async signOut(context: any) {
      await firebase.auth().signOut();

      context.commit("setUserSignedIn", false);
      context.commit("setUser", null);
    }
  }
};

export default auth;
